import { useState } from "react";
import "./../utils/transferByCountry.css";
import { RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { countryInfo } from "../../developer/component/PaymentMethodSelector";
import { FormatCurrency } from "../../../common/format/formatCurrency";

const TransferByCountry = ({ data = [], isLoading }) => {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);

  const cleanData = Array.isArray(data) ? data : [];
  const displayData = showAll ? cleanData : cleanData.slice(0, 3);

  return (
    <div className="transfer-box">
      <div className="transfer-header">
        <div>
          <h3>Paiements par pays</h3>
          <p>Suivi en temps réel des paiements entrants</p>
        </div>

        {cleanData.length > 3 && (
          <button
            className="transfer-toggle-btn"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Voir moins" : "Voir plus"}
          </button>
        )}

        {!cleanData.length && !isLoading && (
          <p style={{ textAlign: "center", color: "#999" }}>
            Aucun paiement pour le moment.
          </p>
        )}
      </div>

      <Row className="g-3">
        {displayData.map((item, index) => {
          const {
            country,
            balance = 0,
            availableBalance = 0,
            transactionCount = 0,
            businessCount = 0,
            currency,
            mainMethod = "—",
          } = item;

          const { name: countryName, flag } = countryInfo[country] || {
            name: country,
            flag: null,
          };

          return (
            <Col lg="4" md="4" sm="6" xs="12" key={index}>
              <div
                className="transfer-card"
                onClick={() =>
                  navigate(`/dashboard/detail-country/${country}`, {
                    state: { countryName, flag, countryCode: country },
                  })
                }
                style={{ cursor: "pointer" }}
              >
                <div className="transfer-card-header">
                  <div className="flag-name">
                    {flag && (
                      <img
                        src={flag}
                        alt={`${countryName} flag`}
                        className="flag-img"
                      />
                    )}
                    <span className="name">{countryName}</span>
                  </div>
                  <RightOutlined />
                </div>

                <div className="transfer-info-line">
                  <span className="label">Revenus</span>
                  <span className="value">
                    {FormatCurrency(Number(balance), currency)}
                  </span>
                </div>
                <div className="transfer-info-line">
                  <span className="label">Transactions</span>
                  <span className="value">{transactionCount}</span>
                </div>
                <div className="transfer-info-line">
                  <span className="label">Business</span>
                  <span className="value">{businessCount}</span>
                </div>

                <hr className="separator" />

                <div className="transfer-info-line">
                  <span className="label">Montant disponible</span>
                  <a href="#" className="main-method">
                    {availableBalance}
                  </a>
                </div>
                {/* <div className="transfer-info-line">
                  <span className="label">Méthode principale</span>
                  <a href="#" className="main-method">
                    {mainMethod}
                  </a>
                </div> */}
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default TransferByCountry;
